import { Card, styled } from '../../../base';

export const CardWrapper = styled(Card)(() => ({
    padding: 5,
    display: 'flex',
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'visible',
    zIndex: 1,
}));
